export enum DateFormats {
    None = 'none',
    TwelveHourFormat = '12hour',
    MonthYear = 'monthYear',
    MonthDayYear = 'monthDayYear',
    DayMonthNameYear = 'dayMonthNameYear',
    MonthNameDayYear = 'monthNameDayYear'
}
